import React from 'react';
import PropTypes from 'prop-types';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import Cookie from 'react-cookie';
import { LocaleSelectorModal } from './locale-selector-modal';

export class LocaleSelector extends React.Component {
    constructor(props) {
        super(props);
        const currentLocale = Cookie.load('preferred_locale') || Cookie.load('initial_locale');
        const envLocaleMap = SharedIntlProviderHOC.getEnvLocaleData() || {};
        this.state = {
            showModal: false,
            currentLocaleData: { ...envLocaleMap[currentLocale], locale: currentLocale }
        };
        this.openSelectorModal = this.openSelectorModal.bind(this);
        this.onSelectorModalClose = this.onSelectorModalClose.bind(this);
    }

    openSelectorModal () {
        this.setState({
            showModal: true
        })
    }

    onSelectorModalClose () {
        this.setState({
            showModal: false
        });
    }

    render () {
        const { children, activeLocales, source} = this.props;
        const { showModal, currentLocaleData } = this.state;
      return (
        <button className="btn-link no-gutter remove-click-styling nav-locale-button" onClick={this.openSelectorModal}>
          {children}
          {showModal && <LocaleSelectorModal showModal={showModal} onModalClose={this.onSelectorModalClose} currentLocaleData={{ ...currentLocaleData }} activeLocales={activeLocales} triggerSource={source} />}
        </button>
      );
    }
}
LocaleSelector.propTypes = {
    children: PropTypes.node.isRequired,
    source: PropTypes.string.isRequired
};